import { openBlock as e, createElementBlock as t, createElementVNode as c } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ c("path", { d: "M12.003 6.125c-.25.003-.488.093-.666.252l-8.805 8.02a.86.86 0 0 0-.209.281.794.794 0 0 0 0 .665c.049.105.12.2.21.28a.984.984 0 0 0 .666.252c.25 0 .49-.09.666-.251l8.138-7.425 8.138 7.425c.177.16.417.251.667.251.25 0 .49-.09.666-.251a.822.822 0 0 0 .276-.608c0-.227-.1-.446-.276-.607L12.67 6.39a.938.938 0 0 0-.304-.194 1.01 1.01 0 0 0-.363-.07Z" }, null, -1), r = [
  n
];
function s(a, l) {
  return e(), t("svg", o, [...r]);
}
const _ = { render: s };
export {
  _ as default,
  s as render
};
